var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFretefy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "28.000000pt",
    height: "28.000000pt",
    viewBox: "0 0 28.000000 28.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,28.000000) scale(0.100000,-0.100000)",
    fill: "#707070",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 140 l0 -140 140 0 140 0 0 140 0 140 -140 0 -140 0 0 -140z m198 64 c32 -37 28 -68 -17 -117 l-40 -42 -40 40 c-50 48 -55 92 -15 132 20 20 32 24 57 19 18 -3 42 -17 55 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 203 c-20 -7 -40 -33 -40 -51 0 -12 4 -12 20 3 11 10 26 15 36 11 15 -6 14 -9 -6 -32 l-24 -24 23 -23 c13 -12 21 -16 17 -9 -4 7 2 24 13 38 26 33 27 56 3 77 -20 18 -19 18 -42 10z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFretefy);
export default __webpack_public_path__ + "static/media/fretefy.4783e398.svg";
export { ForwardRef as ReactComponent };